var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { attrs: { action: "#l", method: "post" } }, [
      _c("div", { staticClass: "title-container" }, [
        _c("h2", { staticClass: "search-title" }, [
          _vm._v(_vm._s(_vm.searchboxheadlineflightseat[_vm.getCurrentLocale])),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(_vm._s(_vm.searchboxheadlineflights2[_vm.getCurrentLocale])),
        ]),
        _vm._v(" "),
        _c("i", { staticClass: "soap-icon-passenger" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "search-content" }, [
        _c(
          "div",
          {
            staticClass: "col-md-12",
            staticStyle: { "margin-bottom": "0px" },
            attrs: { id: "main" },
          },
          [
            _c("h4", { staticClass: "skin-color" }, [
              _vm._v(_vm._s(_vm.seatstitle[_vm.getCurrentLocale])),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.seatstitle2[_vm.getCurrentLocale]))]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", { staticClass: "image-box style9 column-4" }, [
              _c(
                "article",
                { staticClass: "box" },
                [
                  _c("center", [
                    _c("figure", [
                      _c("a", { attrs: { href: "#", title: "" } }, [
                        _c("img", {
                          staticStyle: { "background-color": "#FF6600" },
                          attrs: {
                            src: "/res/images/services/seats/types/seat1.png",
                            alt: "",
                            width: "30",
                            height: "30",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "details" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "20px",
                          },
                          attrs: {
                            href: "/infos-seat-reservation/#/seat-reservation",
                            title: "",
                            target: "_new",
                          },
                        },
                        [_vm._v(_vm._s(_vm.moreinfo[_vm.getCurrentLocale]))]
                      ),
                      _vm._v(" "),
                      _c("h4", { staticClass: "box-title" }, [
                        _vm._v("\n                                    Comfort"),
                        _c("br"),
                        _vm._v("Seat"),
                        _c("br"),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-top": "5px",
                              "margin-bottom": "10px",
                              "font-size": "20px",
                              color: "rgb(125, 185, 33)",
                            },
                          },
                          [_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(30))))]
                        ),
                        _vm._v(" "),
                        _c("small", [
                          _c("br"),
                          _vm._v(
                            _vm._s(
                              _vm.furtherservices_seat_comfortseat[
                                _vm.getCurrentLocale
                              ]
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "article",
                { staticClass: "box" },
                [
                  _c("center", [
                    _c("figure", [
                      _c("a", { attrs: { href: "#", title: "" } }, [
                        _c("img", {
                          staticStyle: { "background-color": "#9900CC" },
                          attrs: {
                            src: "/res/images/services/seats/types/seat1.png",
                            alt: "",
                            width: "30",
                            heigth: "30",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "details" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "20px",
                          },
                          attrs: {
                            href: "/infos-seat-reservation/#/seat-reservation",
                            title: "",
                            target: "_new",
                          },
                        },
                        [_vm._v(_vm._s(_vm.moreinfo[_vm.getCurrentLocale]))]
                      ),
                      _vm._v(" "),
                      _c("h4", { staticClass: "box-title" }, [
                        _vm._v("\n                                    Best"),
                        _c("br"),
                        _vm._v("Seat"),
                        _c("br"),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-top": "5px",
                              "margin-bottom": "10px",
                              "font-size": "20px",
                              color: "rgb(125, 185, 33)",
                            },
                          },
                          [_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(20))))]
                        ),
                        _vm._v(" "),
                        _c("small", [
                          _c("br"),
                          _vm._v(
                            _vm._s(
                              _vm.furtherservices_seat_bestseat[
                                _vm.getCurrentLocale
                              ]
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "article",
                { staticClass: "box" },
                [
                  _c("center", [
                    _c("figure", [
                      _c("a", { attrs: { href: "#", title: "" } }, [
                        _c("img", {
                          staticStyle: { "background-color": "#22B14C" },
                          attrs: {
                            src: "/res/images/services/seats/types/seat1.png",
                            alt: "",
                            width: "30",
                            heigth: "30",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "details" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "20px",
                          },
                          attrs: {
                            href: "/infos-seat-reservation/#/seat-reservation",
                            title: "",
                            target: "_new",
                          },
                        },
                        [_vm._v(_vm._s(_vm.moreinfo[_vm.getCurrentLocale]))]
                      ),
                      _vm._v(" "),
                      _c("h4", { staticClass: "box-title" }, [
                        _vm._v(
                          "\n                                    Standard"
                        ),
                        _c("br"),
                        _vm._v("Seat"),
                        _c("br"),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-top": "5px",
                              "margin-bottom": "10px",
                              "font-size": "20px",
                              color: "rgb(125, 185, 33)",
                            },
                          },
                          [_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(15))))]
                        ),
                        _vm._v(" "),
                        _c("small", [_c("br")]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "article",
                { staticClass: "box" },
                [
                  _c("center", [
                    _c("figure", [
                      _c("a", { attrs: { href: "#", title: "" } }, [
                        _c("img", {
                          staticStyle: { "background-color": "#3399FF" },
                          attrs: {
                            src: "/res/images/services/seats/types/seat1.png",
                            alt: "",
                            width: "30",
                            heigth: "30",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "details" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "20px",
                          },
                          attrs: {
                            href: "/infos-seat-reservation/#/seat-reservation",
                            title: "",
                            target: "_new",
                          },
                        },
                        [_vm._v(_vm._s(_vm.moreinfo[_vm.getCurrentLocale]))]
                      ),
                      _vm._v(" "),
                      _c("h4", { staticClass: "box-title" }, [
                        _vm._v("\n                                    Exit"),
                        _c("br"),
                        _vm._v("Seat"),
                        _c("br"),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-top": "5px",
                              "margin-bottom": "10px",
                              "font-size": "20px",
                              color: "rgb(125, 185, 33)",
                            },
                          },
                          [_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(30))))]
                        ),
                        _vm._v(" "),
                        _c("small", [
                          _c("br"),
                          _vm._v(
                            _vm._s(
                              _vm.furtherservices_seat_exitseat[
                                _vm.getCurrentLocale
                              ]
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tab-pane fade in active image-style style2",
            attrs: { id: "honeymoon1" },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("br"),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "button btn-medium icon-check uppercase full-width",
                attrs: { href: "/services" },
              },
              [_vm._v(_vm._s(_vm.seatsbutton[_vm.getCurrentLocale]))]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 column-in-center" }, [
        _c("ul", { staticClass: "image-block clearfix" }, [
          _c("li", { staticStyle: { "z-index": "5", left: "50px" } }, [
            _c(
              "a",
              {
                staticClass: "middle-block",
                staticStyle: {
                  width: "80px",
                  height: "80px",
                  position: "relative",
                },
                attrs: { href: "/services" },
              },
              [
                _c("img", {
                  staticClass: "middle-item",
                  staticStyle: {
                    position: "absolute",
                    top: "50%",
                    "margin-top": "-40px",
                    left: "50%",
                    "margin-left": "-66.5px",
                  },
                  attrs: {
                    width: "133",
                    height: "88",
                    alt: "",
                    src: "/res/images/services/seats/tabs_banner_5.png",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "li",
            { staticStyle: { "z-index": "4", left: "180px", top: "100px" } },
            [
              _c(
                "a",
                {
                  staticClass: "middle-block",
                  staticStyle: {
                    width: "100px",
                    height: "100px",
                    position: "relative",
                  },
                  attrs: { href: "/services" },
                },
                [
                  _c("img", {
                    staticClass: "middle-item",
                    staticStyle: {
                      position: "absolute",
                      top: "50%",
                      "margin-top": "-50px",
                      left: "50%",
                      "margin-left": "-75px",
                    },
                    attrs: {
                      width: "150",
                      height: "100",
                      alt: "",
                      src: "/res/images/services/seats/tabs_banner_4.jpg",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticStyle: { "z-index": "3", left: "250px", top: "20px" } },
            [
              _c(
                "a",
                {
                  staticClass: "middle-block",
                  staticStyle: {
                    width: "150px",
                    height: "150px",
                    position: "relative",
                  },
                  attrs: { href: "/services" },
                },
                [
                  _c("img", {
                    staticClass: "middle-item",
                    staticStyle: {
                      position: "absolute",
                      top: "50%",
                      "margin-top": "-75px",
                      left: "50%",
                      "margin-left": "-110px",
                    },
                    attrs: {
                      width: "220",
                      height: "196",
                      alt: "",
                      src: "/res/images/services/seats/tabs_banner_2.png",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticStyle: { "z-index": "2", left: "100px", top: "0" } },
            [
              _c(
                "a",
                {
                  staticClass: "middle-block",
                  staticStyle: {
                    width: "160px",
                    height: "160px",
                    position: "relative",
                  },
                  attrs: { href: "/services" },
                },
                [
                  _c("img", {
                    staticClass: "middle-item",
                    staticStyle: {
                      position: "absolute",
                      top: "50%",
                      "margin-top": "-80px",
                      left: "50%",
                      "margin-left": "-156px",
                    },
                    attrs: {
                      width: "312",
                      height: "208",
                      alt: "",
                      src: "/res/images/services/seats/tabs_banner_3.png",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticStyle: { "z-index": "1", left: "0", top: "30px" } },
            [
              _c(
                "a",
                {
                  staticClass: "middle-block",
                  staticStyle: {
                    width: "156px",
                    height: "156px",
                    position: "relative",
                  },
                  attrs: { href: "/services" },
                },
                [
                  _c("img", {
                    staticClass: "middle-item",
                    staticStyle: {
                      position: "absolute",
                      top: "50%",
                      "margin-top": "-78px",
                      left: "50%",
                      "margin-left": "-117.5px",
                    },
                    attrs: {
                      width: "235",
                      height: "156",
                      alt: "",
                      src: "/res/images/services/seats/tabs_banner_1.jpg",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }